interface ShortUrlErrorProps {
  error: string;
  onRetry?: () => void;
}

export function ShortUrlError({ error, onRetry }: ShortUrlErrorProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8">
        <div className="text-center">
          <div className="text-6xl mb-4">🔗</div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Payment Link Error
          </h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <p className="text-sm text-gray-500 mb-6">
            This link may have expired, been mistyped, or is no longer valid.
          </p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition"
            >
              Try Again
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
